import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { ErrorMessage, StyledButton, Input } from '../../../components/simple';
import styles from './styles.module.scss';
import { forgotPasswordPage, mainPage } from '../../../router/routes';
import { post } from '../../../services/API';
import useMultiLang from '../../../localization/useMultiLang';

const LoginForm = () => {
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { t } = useMultiLang();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: async (values) => {
      const data = await post('auth/', values);
      if (data.status === 200) {
        localStorage.setItem('token', data.data.token);
        navigate(mainPage);
      } else {
        setError(true);
      }
    },
  });
  return (
    <div className={styles.loginForm}>
      <form onSubmit={formik.handleSubmit} className={styles.form}>
        <Input name="email" type="text" onChange={formik.handleChange} value={formik.values.email} label={t('email')} />
        <Input
          name="password"
          type="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          label={t('password')}
        />
        {error && <ErrorMessage text={t('login_error')} />}
        <StyledButton type="submit" color="yellow" text={t('login')} className={styles.button} />
      </form>
      <Link to={forgotPasswordPage} className={styles.link}>
        {t('forgot_password')}
      </Link>
    </div>
  );
};

export default LoginForm;
